import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Moon } from "lucide-react";

export default function EventBanner() {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    let mounted = true;
    const refresh = () => api.eventCurrent().then(e => mounted && setEvent(e)).catch(() => {});
    refresh();
    const t = setInterval(refresh, 60000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (!event?.active) return null;

  return (
    <div
      data-testid="event-banner"
      className="px-3 py-1 border-b border-[#8A0303] flex items-center justify-between"
      style={{
        background: "linear-gradient(to right, rgba(138,3,3,0.25), rgba(138,3,3,0.05))",
      }}
    >
      <div className="flex items-center gap-2">
        <Moon className="w-3 h-3 text-[#E33333] ember-pulse" strokeWidth={1.5} />
        <span className="font-heading text-[10px] tracking-[0.3em] uppercase text-[#E33333]">
          {event.name}
        </span>
      </div>
      <span className="font-mono text-[10px] text-[#8c8c8c] truncate ml-2">
        Double gold & xp on steps
      </span>
    </div>
  );
}
